<aside class="sidebar" [class.sidebar--tour-active]="isTourActive()">
  <!-- Dim + blur the page; .tour-highlight punches through above this layer -->
  <div
    class="tour-backdrop"
    *ngIf="isTourActive()"
    aria-hidden="true"
  ></div>

  <!-- Mobile/Tablet Navigation Bar (md devices) -->
  <div class="sidebar__mobile-bar">
    <div class="sidebar__mobile-content">
      <!-- Panel Name -->
      <div class="sidebar__mobile-panel">
        <div class="sidebar__logo">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
            <path d="M2 17l10 5 10-5"></path>
            <path d="M2 12l10 5 10-5"></path>
          </svg>
        </div>
        <h1 class="sidebar__mobile-title">{{ headerLabel || 'Consumer' }}</h1>
      </div>
      
      <!-- Active Page Selector -->
      <div class="sidebar__mobile-selector">
        <div class="sidebar__mobile-input" (click)="toggleOffcanvas()">
          <svg class="menu-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="3" width="7" height="7"></rect>
            <rect x="14" y="3" width="7" height="7"></rect>
            <rect x="14" y="14" width="7" height="7"></rect>
            <rect x="3" y="14" width="7" height="7"></rect>
          </svg>
          <span class="current-page" [attr.title]="currentPageLabel">{{ currentPageLabel }}</span>
          <svg class="chevron-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>
      </div>
    </div>
  </div>

  <!-- Desktop Sidebar Header -->
  <div class="sidebar__header">
    <div class="sidebar__header-container">
      <div class="sidebar__header-content">
        <div class="sidebar__logo">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
            <path d="M2 17l10 5 10-5"></path>
            <path d="M2 12l10 5 10-5"></path>
          </svg>
        </div>
        <h1 class="sidebar__title">{{ headerLabel || 'Consumer' }}</h1>
      </div>
    </div>
  </div>

  <!-- Desktop Sidebar Navigation -->
  <nav class="sidebar__nav">
    <ul class="sidebar__menu">
      <li 
        *ngFor="let item of menuItems" 
        class="sidebar__menu-item"
        [class.has-children]="item.children && item.children.length > 0"
        [class.dropdown-open]="isDropdownOpen(item.label)"
      >
        <!-- Parent item with dropdown -->
        <div 
          *ngIf="item.children && item.children.length > 0"
          class="sidebar__menu-link sidebar__menu-link--dropdown"
          [class.tour-highlight]="isTourHighlighted(item.label)"
          #tourTarget
          [attr.data-tour-label]="item.label"
          [attr.title]="item.label"
          (click)="toggleItemDropdown(item.label, $event)"
        >
          <span class="sidebar__menu-icon" *ngIf="item.safeIcon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <g [innerHTML]="item.safeIcon"></g>
            </svg>
          </span>
          <span class="sidebar__menu-label" [attr.data-label]="item.label">{{ item.label }}</span>
          <svg 
            class="sidebar__dropdown-arrow"
            [class.rotated]="isDropdownOpen(item.label)"
            width="16" 
            height="16" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            stroke-width="2" 
            stroke-linecap="round" 
            stroke-linejoin="round"
          >
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>
        
        <!-- Regular link item -->
        <a 
          *ngIf="!item.children || item.children.length === 0"
          [routerLink]="item.route"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: false}"
          class="sidebar__menu-link"
          [class.tour-highlight]="isTourHighlighted(item.label)"
          #tourTarget
          [attr.data-tour-label]="item.label"
          [attr.title]="item.label"
          (click)="handleMenuClick(item)"
        >
          <span class="sidebar__menu-icon" *ngIf="item.safeIcon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <g [innerHTML]="item.safeIcon"></g>
            </svg>
          </span>
          <span class="sidebar__menu-label" [attr.data-label]="item.label">{{ item.label }}</span>
        </a>
        
        <!-- Dropdown children -->
        <ul 
          *ngIf="item.children && item.children.length > 0 && isDropdownOpen(item.label)"
          class="sidebar__submenu"
        >
          <li 
            *ngFor="let child of item.children" 
            class="sidebar__submenu-item"
            [class.sidebar__submenu-separator]="!child.route && (child.label === '---' || child.label === 'separator')"
          >
            <a 
              *ngIf="child.route"
              [routerLink]="child.route"
              [queryParams]="child.queryParams || null"
              [class.active]="isMenuItemActive(child)"
              class="sidebar__submenu-link"
              [attr.title]="child.label"
              (click)="handleMenuClick(child, $event)"
            >
              <span class="sidebar__submenu-label">{{ child.label }}</span>
            </a>
            <div 
              *ngIf="!child.route && (child.label === '---' || child.label === 'separator')"
              class="sidebar__submenu-separator-line"
            ></div>
          </li>
        </ul>
      </li>
      
      <!-- Call to Action as Menu Item -->
      <li class="sidebar__menu-item sidebar__cta-item" *ngIf="callToAction">
        <a 
          *ngIf="callToAction.linkRoute"
          [routerLink]="callToAction.linkRoute"
          [class.active]="isOrganisationRouteActive()"
          class="sidebar__menu-link sidebar__cta-link"
          [attr.title]="callToAction.title"
        >
          <span class="sidebar__menu-icon" *ngIf="callToAction.safeIcon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <g [innerHTML]="callToAction.safeIcon"></g>
            </svg>
          </span>
          <span class="sidebar__cta-content">
            <span class="sidebar__cta-title">{{ callToAction.title }}</span>
            <span class="sidebar__cta-description">{{ callToAction.description }}</span>
            <span class="sidebar__cta-button-text">{{ callToAction.linkText }} →</span>
          </span>
        </a>
        <a 
          *ngIf="callToAction.linkHref && !callToAction.linkRoute"
          [href]="callToAction.linkHref"
          class="sidebar__menu-link sidebar__cta-link"
          [attr.title]="callToAction.title"
        >
          <span class="sidebar__menu-icon" *ngIf="callToAction.safeIcon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <g [innerHTML]="callToAction.safeIcon"></g>
            </svg>
          </span>
          <span class="sidebar__cta-content">
            <span class="sidebar__cta-title">{{ callToAction.title }}</span>
            <span class="sidebar__cta-description">{{ callToAction.description }}</span>
            <span class="sidebar__cta-button-text" *ngIf="callToAction.linkText">{{ callToAction.linkText }} →</span>
          </span>
        </a>
        <div 
          *ngIf="!callToAction.linkRoute && !callToAction.linkHref"
          class="sidebar__menu-link sidebar__cta-link sidebar__cta-link--disabled"
          [attr.title]="callToAction.title"
        >
          <span class="sidebar__menu-icon" *ngIf="callToAction.safeIcon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <g [innerHTML]="callToAction.safeIcon"></g>
            </svg>
          </span>
          <span class="sidebar__cta-content">
            <span class="sidebar__cta-title">{{ callToAction.title }}</span>
            <span class="sidebar__cta-description">{{ callToAction.description }}</span>
          </span>
        </div>
      </li>
    </ul>
  </nav>

  <!-- Panel Demo sits above the Profile/Support footer strip -->
  <div class="sidebar__demo">
    <button
      type="button"
      class="sidebar__demo-btn"
      title="Panel Demo"
      (click)="startTour($event)"
    >
      <span class="sidebar__footer-icon" *ngIf="demoSafeIcon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <g [innerHTML]="demoSafeIcon"></g>
        </svg>
      </span>
      <span class="sidebar__footer-label">Panel Demo</span>
    </button>
  </div>

  <!-- Desktop Sidebar Footer (Profile / Support only). Hidden in a delegate session. -->
  @if (footerItems.length) {
  <div class="sidebar__footer">
    <a 
      *ngFor="let item of footerItems"
      [routerLink]="item.route ? [item.route] : null"
      [href]="item.href"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{exact: false}"
      class="sidebar__footer-item"
      [class.tour-highlight]="isTourHighlighted(item.label)"
      #tourTarget
      [attr.data-tour-label]="item.label"
      [attr.title]="item.label"
      (click)="handleMenuClick(item)"
    >
      <span class="sidebar__footer-icon" *ngIf="item.safeIcon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <g [innerHTML]="item.safeIcon"></g>
        </svg>
      </span>
      <span class="sidebar__footer-label">{{ item.label }}</span>
    </a>
  </div>
  }
</aside>

<!-- Offcanvas Menu (Mobile/Tablet) -->
<div
  class="sidebar-offcanvas"
  [class.open]="offcanvasOpen"
  [class.sidebar-offcanvas--tour]="isTourStepActive()"
>
  <div class="offcanvas-backdrop" (click)="closeOffcanvas()"></div>
  <div class="offcanvas-content">
    <div class="offcanvas-header">
      <h2 class="offcanvas-title">Menu</h2>
      <button class="offcanvas-close" (click)="closeOffcanvas()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
    
    <nav class="offcanvas-nav">
      <ul class="offcanvas-menu">
        <li 
          *ngFor="let item of menuItems" 
          class="offcanvas-menu-item"
          [class.has-children]="item.children && item.children.length > 0"
          [class.dropdown-open]="isDropdownOpen(item.label)"
        >
          <!-- Parent item with dropdown -->
          <div 
            *ngIf="item.children && item.children.length > 0"
            class="offcanvas-menu-link offcanvas-menu-link--dropdown"
            [class.tour-highlight]="isTourHighlighted(item.label)"
            #tourTarget
            [attr.data-tour-label]="item.label"
            [attr.title]="item.label"
            (click)="toggleItemDropdown(item.label, $event)"
          >
            <span class="offcanvas-menu-icon" *ngIf="item.safeIcon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <g [innerHTML]="item.safeIcon"></g>
              </svg>
            </span>
            <span class="offcanvas-menu-label" [attr.data-label]="item.label">{{ item.label }}</span>
            <svg 
              class="offcanvas-dropdown-arrow"
              [class.rotated]="isDropdownOpen(item.label)"
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              stroke-width="2" 
              stroke-linecap="round" 
              stroke-linejoin="round"
            >
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </div>
          
          <!-- Regular link item -->
          <a 
            *ngIf="!item.children || item.children.length === 0"
            [routerLink]="item.route"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: false}"
            class="offcanvas-menu-link"
            [class.tour-highlight]="isTourHighlighted(item.label)"
            #tourTarget
            [attr.data-tour-label]="item.label"
            [attr.title]="item.label"
            (click)="handleMenuClick(item); closeOffcanvas()"
          >
            <span class="offcanvas-menu-icon" *ngIf="item.safeIcon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <g [innerHTML]="item.safeIcon"></g>
              </svg>
            </span>
            <span class="offcanvas-menu-label" [attr.data-label]="item.label">{{ item.label }}</span>
          </a>
          
          <!-- Dropdown children -->
          <ul 
            *ngIf="item.children && item.children.length > 0 && isDropdownOpen(item.label)"
            class="offcanvas-submenu"
          >
            <li 
              *ngFor="let child of item.children" 
              class="offcanvas-submenu-item"
            >
              <a 
                *ngIf="child.route"
                [routerLink]="child.route"
                [queryParams]="child.queryParams || null"
                [class.active]="isMenuItemActive(child)"
                class="offcanvas-submenu-link"
                [attr.title]="child.label"
                (click)="handleMenuClick(child); closeOffcanvas(); $event.stopPropagation()"
              >
                <span class="offcanvas-submenu-label">{{ child.label }}</span>
              </a>
            </li>
          </ul>
        </li>
        
        <!-- Call to Action as Menu Item in Offcanvas -->
        <li class="offcanvas-menu-item offcanvas-cta-item" *ngIf="callToAction">
          <a 
            *ngIf="callToAction.linkRoute"
            [routerLink]="callToAction.linkRoute"
            [class.active]="isOrganisationRouteActive()"
            class="offcanvas-menu-link offcanvas-cta-link"
            [attr.title]="callToAction.title"
            (click)="closeOffcanvas()"
          >
            <span class="offcanvas-menu-icon" *ngIf="callToAction.safeIcon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <g [innerHTML]="callToAction.safeIcon"></g>
              </svg>
            </span>
            <span class="offcanvas-cta-content">
              <span class="offcanvas-cta-title">{{ callToAction.title }}</span>
              <span class="offcanvas-cta-description">{{ callToAction.description }}</span>
              <span class="offcanvas-cta-button-text" *ngIf="callToAction.linkText">{{ callToAction.linkText }} →</span>
            </span>
          </a>
          <a 
            *ngIf="callToAction.linkHref && !callToAction.linkRoute"
            [href]="callToAction.linkHref"
            class="offcanvas-menu-link offcanvas-cta-link"
            [attr.title]="callToAction.title"
            (click)="closeOffcanvas()"
          >
            <span class="offcanvas-menu-icon" *ngIf="callToAction.safeIcon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <g [innerHTML]="callToAction.safeIcon"></g>
              </svg>
            </span>
            <span class="offcanvas-cta-content">
              <span class="offcanvas-cta-title">{{ callToAction.title }}</span>
              <span class="offcanvas-cta-description">{{ callToAction.description }}</span>
              <span class="offcanvas-cta-button-text" *ngIf="callToAction.linkText">{{ callToAction.linkText }} →</span>
            </span>
          </a>
          <div 
            *ngIf="!callToAction.linkRoute && !callToAction.linkHref"
            class="offcanvas-menu-link offcanvas-cta-link offcanvas-cta-link--disabled"
            [attr.title]="callToAction.title"
          >
            <span class="offcanvas-menu-icon" *ngIf="callToAction.safeIcon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <g [innerHTML]="callToAction.safeIcon"></g>
              </svg>
            </span>
            <span class="offcanvas-cta-content">
              <span class="offcanvas-cta-title">{{ callToAction.title }}</span>
              <span class="offcanvas-cta-description">{{ callToAction.description }}</span>
            </span>
          </div>
        </li>
      </ul>

      <!-- Panel Demo sits above the Profile/Support footer strip -->
      <div class="offcanvas-demo">
        <button
          type="button"
          class="offcanvas-menu-link offcanvas-menu-link--demo"
          title="Panel Demo"
          (click)="startTour($event)"
        >
          <span class="offcanvas-menu-icon" *ngIf="demoSafeIcon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <g [innerHTML]="demoSafeIcon"></g>
            </svg>
          </span>
          <span class="offcanvas-menu-label" data-label="Panel Demo">Panel Demo</span>
        </button>
      </div>
      
      @if (footerItems.length) {
      <div class="offcanvas-footer-links">
        <a 
          *ngFor="let item of footerItems"
          [routerLink]="item.route ? [item.route] : null"
          [href]="item.href"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: false}"
          class="offcanvas-menu-link"
          [class.tour-highlight]="isTourHighlighted(item.label)"
          #tourTarget
          [attr.data-tour-label]="item.label"
          [attr.title]="item.label"
          (click)="handleMenuClick(item); closeOffcanvas()"
        >
          <span class="offcanvas-menu-icon" *ngIf="item.safeIcon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <g [innerHTML]="item.safeIcon"></g>
            </svg>
          </span>
          <span class="offcanvas-menu-label" [attr.data-label]="item.label">{{ item.label }}</span>
        </a>
      </div>
      }
    </nav>
  </div>
</div>
